<script lang="ts">
  import {
    Auth0LoginButton,
    Auth0LogoutButton,
    isAuthenticated,
  } from '@dopry/svelte-auth0';
</script>

<header>
  <div class="header-row">
    <h1>rate your image!</h1>
    {#if $isAuthenticated}
      <Auth0LogoutButton class="auth-button">Logout</Auth0LogoutButton>
    {:else}
      <Auth0LoginButton class="auth-button">Login</Auth0LoginButton>
    {/if}
  </div>
</header>

<style>
  header {
    flex: 0 0 50px;
    width: 100%;
    background: #fff8f0;
  }
  .header-row {
    flex: 1 1 auto;
    overflow: hidden;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    padding: 10px 10px 0;
  }
  .header-row :global(.auth-button) {
    margin-left: 2em;
  }
</style>
